import Banner from '../components/Banner';
import home from '../img/home.jpg';
import home2 from '../img/home2.jpg';
import home3 from '../img/home3.jpg';
import reference from "../img/reference.jpg"
import reference2 from "../img/reference2.jpg"
import reference3 from "../img/reference3.jpg"
import Card from '../components/Card';
import { useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function Home() {

  useEffect(() => {
    document.title = "Hem";
  });

  const slideImages = [
    home,
    home2,
    home3
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 11000,
  };

  return (
    <>
      <div className='home-page-image-container '>
        <Slider {...settings} >
          {slideImages.map((img, index) => (
            <div key={index} >
              <img src={img} alt={`Slide ${index + 1}`}
                style={{

                  objectFit: 'cover',
                }} />
            </div>
          ))}
        </Slider>
      </div>
      <Banner />
      <div className='px-lg-6 px-4 d-flex justify-content-xxl-between justify-content-center flex-wrap card-container-p-0'>
        <Card img={reference} />
        <Card img={reference2} />
        <Card img={reference3} />
      </div>
    </>
  )
}